// extracted by mini-css-extract-plugin
module.exports = {"container":"Sd","copy":"Td","field":"Ud","error":"Vd","disabled":"Wd","termsContainer":"Xd","termsHeading":"Yd","termsCopy":"Zd","submit":"_d","srOnly":"ae"};